/* CH#49502: Used by CVR */
import classNames from 'classnames';
import { Mask, Text } from '@farmersdog/corgi-x';
import { Heart } from '@farmersdog/corgi-x/icons';

import Picture, { LoadingOption } from 'src/components/Picture';

import styles from './InstagramCard.module.css';
import type { ReactNode } from 'react';

type InstagramCardProps = {
  icon: string;
  screenName: string;
  sources: string[];
  quote: ReactNode;
  className?: string;
};

export function InstagramCard({
  icon,
  screenName,
  sources,
  quote,
  className,
}: InstagramCardProps) {
  return (
    <figure className={classNames(styles.card, className)}>
      <figcaption className={styles.user}>
        <Mask shape="circle" size="sm">
          <Picture sources={[icon]} alt={`${screenName} profile`} />
        </Mask>
        <Text
          className={styles.screenName}
          variant="heading-16"
          color="kale-3"
          bold
        >
          {screenName}
        </Text>
      </figcaption>
      <Picture
        className={styles.image}
        sources={sources}
        loading={LoadingOption.lazy}
        alt={`${screenName} post`}
      />
      <div className={styles.content}>
        <Heart width={24} fill="#d64c4c" />
        <Text
          as="blockquote"
          variant="heading-16"
          color="charcoal-3"
          className={styles.quote}
        >
          {quote}
        </Text>
      </div>
    </figure>
  );
}
